import styled from 'styled-components';

export const Body = styled('div')`
  white-space: pre-line;
  text-align: center;
`;

export const Placeholder = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

export const Image = styled('img')`
  width: ${({ theme: { spacing } }) => spacing(70)};
`;
